import React, { useEffect, useState } from 'react';
import Spinner from 'components/loader/Spinner';
import Header, { ButtonConfig } from 'components/header/Header';
import useClient from 'api/client';
import { Editor, PipelineExecutions } from './components';
import { StackType } from '../Stack/StackDetails';
import EditPipelineModal from './components/EditPipelineModal';
import StatusWithTooltip from 'components/StatusWithTooltip/StatusWithTooltip';
import StackDetails from '../Stack/StackDetails';
import DeleteModal from 'components/modal/DeleteModal';
import useDeletePipeline from './hooks/useDeletePipeline';
import usePipeline from './hooks/usePipeline';
import { NStatusTag } from '@innersource-nn/novoui-react';
import CredentialsModal from './components/CredentialsModal';
import { trackEvent } from 'analytics/AWSRumService';
import { TabsPanel } from 'components/tabs/TabsPanel';
import { useLocation } from 'react-router-dom';

const PipelineView = () => {
    const client = useClient();
    const location = useLocation();

    const { deletePipeline, deleteLoading } = useDeletePipeline();
    const { pipeline, error, loading, fetchData } = usePipeline();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [credentialsModalOpen, setCredentialsModalOpen] = useState(false);

    const buttonConfigs: ButtonConfig[] = [
        {
            label: 'Credentials',
            onClick: () => setCredentialsModalOpen(true),
            icon: 'doselog',
        },
        {
            label: 'Edit',
            onClick: () => setEditModalOpen(true),
            icon: 'edit',
        },
        {
            label: 'Delete',
            onClick: () => setDeleteModalOpen(true),
            red: true,
            icon: 'trash',
        },
    ];

    useEffect(() => {
        if (location.search === '?tab=run') {
            trackEvent('tab_click_pipeline_executions', {
                location: 'pipelines',
            });
        }
    }, [location.search]);
    return (
        <div>
            <DeleteModal
                title="Delete pipeline"
                type="pipeline"
                onClick={deletePipeline}
                loading={deleteLoading}
                visible={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
            />
            <EditPipelineModal
                visible={editModalOpen}
                onClose={() => {
                    setEditModalOpen(false);
                    fetchData();
                }}
            />
            <CredentialsModal
                open={credentialsModalOpen}
                onClose={() => setCredentialsModalOpen(false)}
                region={pipeline.environment.region}
                repo={pipeline.repo}
            />
            {loading ? (
                <Spinner />
            ) : (
                !error && (
                    <div>
                        <Header
                            title={pipeline.label}
                            buttonConfigs={buttonConfigs}
                            backButton
                        />
                        <div className="flex items-center gap-8">
                            <div className="text-true-blue text-sm">
                                Created: {pipeline.created}
                            </div>
                            <NStatusTag
                                label={pipeline.userRoleForPipeline}
                                variant="rounded"
                                icon="person"
                            />
                            <StatusWithTooltip
                                content={
                                    pipeline.runs[0]?.JobRunState.toUpperCase() ||
                                    pipeline.stack?.status
                                }
                            />
                        </div>
                        <TabsPanel
                            content={[
                                {
                                    id: 'overview',
                                    label: 'Overview',
                                    content: <Editor />,
                                },
                                {
                                    id: 'run',
                                    label: 'Run',
                                    content: (
                                        <PipelineExecutions
                                            pipeline={pipeline}
                                        />
                                    ),
                                },
                                {
                                    id: 'stack',
                                    label: 'Stack ',
                                    content: (
                                        <StackDetails
                                            type={StackType.pipeline}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                )
            )}
        </div>
    );
};

export default PipelineView;
